<template>
  <v-container fluid>
    <v-card class="pa-4">
      <!-- Header -->
      <div class="d-flex align-center mb-4">
        <v-icon size="large" class="mr-2" style="color: #ce501b;">mdi-key</v-icon>
        <h2 class="text-h5">Accesos</h2>
      </div>

      <v-row>
        <!-- Columna izquierda - Selector de Usuario -->
        <v-col cols="12" md="4">
          <v-card elevation="2" class="pa-4">
            <h3 class="text-subtitle-1 mb-4">Usuario</h3>
            
            <v-select
              v-model="usuarioSeleccionado"
              :items="usuarios"
              item-title="usuario"
              item-value="idUsuario"
              label="Seleccione:"
              variant="outlined"
              density="comfortable"
              @update:model-value="cargarAccesos"
              clearable
            ></v-select>

            <v-btn
              color="#ce501b"
              block
              @click="grabarAccesos"
              :loading="guardando"
              :disabled="!usuarioSeleccionado"
              elevation="2"
            >
              Grabar
            </v-btn>
          </v-card>
        </v-col>

        <!-- Columna derecha - Checkboxes de Accesos -->
        <v-col cols="12" md="8">
          <v-card elevation="2" class="pa-4">
            <h3 class="text-subtitle-1 mb-4">Accesos</h3>

            <v-row>
              <!-- Columna 1 -->
              <v-col cols="12" sm="4">
             
                <v-checkbox
                  v-model="accesos.importacion"
                  label="Importacion"
                  density="comfortable"
                  hide-details
                  class="mb-2"
                ></v-checkbox>
                
                <v-checkbox
                  v-model="accesos.workflow"
                  label="Explorador"
                  density="comfortable"
                  hide-details
                  class="mb-2"
                ></v-checkbox>
                
              </v-col>

              <!-- Columna 2 -->
              <v-col cols="12" sm="4">
                <v-checkbox
                  v-model="accesos.impresion"
                  label="Impresion"
                  density="comfortable"
                  hide-details
                  class="mb-2"
                ></v-checkbox>
                <!--
                <v-checkbox
                  v-model="accesos.exportacion"
                  label="Exportacion"
                  density="comfortable"
                  hide-details
                  class="mb-2"
                ></v-checkbox>
                 -->
                <v-checkbox
                  v-model="accesos.anotaciones"
                  label="Anotaciones"
                  density="comfortable"
                  hide-details
                  class="mb-2"
                ></v-checkbox>
              </v-col>

              <!-- Columna 3 -->
              <v-col cols="12" sm="4">
                <v-checkbox
                  v-model="accesos.busqueda"
                  label="Busqueda"
                  density="comfortable"
                  hide-details
                  class="mb-2"
                ></v-checkbox>

                <v-checkbox
                  v-model="accesos.auditoria"
                  label="Auditoria"
                  density="comfortable"
                  hide-details
                  class="mb-2"
                ></v-checkbox>
            
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from '@/plugins/axios'
import Swal from 'sweetalert2'

// Variables
const usuarioSeleccionado = ref(null)
const usuarios = ref([])
const guardando = ref(false)

// Accesos (checkboxes)
const accesos = ref({
  prioridad: 0,
  tipo: 'U',
  escaneo: false,
  importacion: false,
  workflow: false,
  impresion: false,
  exportacion: false,
  anotaciones: false,
  busqueda: false,
  auditoria: false,
  vinculacion: false
})

onMounted(async () => {
  await cargarUsuarios()
})

// Cargar lista de usuarios y grupos 
const cargarUsuarios = async () => {
  try {
    const response = await axios.get('/api/Users/list-usuarios-grupos')
    
    if (response.data.success) {
      usuarios.value = response.data.data.filter(u => u.idUsuario !== '00001') // No finltrar el usuario admin
      //console.log('Usuarios y grupos cargados:', usuarios.value.length)     //Usarlo solo para ver los errores en el testeo de Software
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudieron cargar los usuarios',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
    }
  } catch (error) {
    //console.error('Error al cargar usuarios:', error)      //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'Hubo un problema al cargar los usuarios',
      customClass: {
        title: 'swal-title-custom',
        container: 'swal-sobre-modal'
      }
    })
  }
}

// Cargar accesos del usuario seleccionado
const cargarAccesos = async () => {
  if (!usuarioSeleccionado.value) {
    // Limpiar checkboxes si no hay usuario seleccionado
    accesos.value = {
      prioridad: 0,
      tipo: 'U',
      escaneo: false,
      importacion: false,
      workflow: false,
      impresion: false,
      exportacion: false,
      anotaciones: false,
      busqueda: false,
      auditoria: false,
      vinculacion: false
    }
    return
  }

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    
    if (!idUsuarioSesion) {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: 'No se pudo obtener la información del usuario en sesión',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
      return
    }

    //console.log('Cargando accesos para usuario:', usuarioSeleccionado.value)       //Usarlo solo para ver los errores en el testeo de Software

    const response = await axios.get(
      `/api/Accesos/obtener-accesos/${usuarioSeleccionado.value}?idUsuarioSesion=${idUsuarioSesion}`
    )

    if (response.data.success) {
      const data = response.data.data
      
      //console.log('Datos de accesos recibidos:', data)       //Usarlo solo para ver los errores en el testeo de Software
      
      // ✅ Convertir números (0/1) a booleanos (false/true)
      accesos.value = {
        prioridad: data.prioridad ?? 0,
        tipo: data.tipo ?? 'U',
        escaneo: data.escaneo === 1,
        importacion: data.importacion === 1,
        workflow: data.workflow === 1,
        impresion: data.impresion === 1,
        exportacion: data.exportacion === 1,
        anotaciones: data.anotaciones === 1,
        busqueda: data.busqueda === 1,
        auditoria: data.auditoria === 1,
        vinculacion: data.vinculacion === 1
      }
      
      //console.log('Accesos mapeados a checkboxes:', accesos.value)      //Usarlo solo para ver los errores en el testeo de Software
    }
  } catch (error) {
    //console.error('Error al cargar accesos:', error)       //Usarlo solo para ver los errores en el testeo de Software
    // Si no existen accesos, inicializar en false
    accesos.value = {
      
      escaneo: false,
      importacion: false,
      workflow: false,
      impresion: false,
      exportacion: false,
      anotaciones: false,
      busqueda: false,
      auditoria: false,
      vinculacion: false
    }
  }
}

// Grabar accesos
const grabarAccesos = async () => {
  if (!usuarioSeleccionado.value) {
    Swal.fire({
      icon: 'warning',
      iconColor: '#ce501b',
      title: 'Advertencia',
      text: 'Debe seleccionar un usuario',
      customClass: {
        title: 'swal-title-custom',
        container: 'swal-sobre-modal'
      }
    })
    return
  }

  guardando.value = true

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    
    if (!idUsuarioSesion) {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: 'No se pudo obtener la información del usuario en sesión',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
      guardando.value = false
      return
    }

    const payload = {
      prioridad: accesos.value.prioridad ?? 0,
      idUsuario: usuarioSeleccionado.value,
      tipo: accesos.value.tipo ?? 'U',
      escaneo: accesos.value.escaneo ? 1 : 0,
      impresion: accesos.value.impresion ? 1 : 0,
      busqueda: accesos.value.busqueda ? 1 : 0,
      importacion: accesos.value.importacion ? 1 : 0,
      exportacion: accesos.value.exportacion ? 1 : 0,
      auditoria: accesos.value.auditoria ? 1 : 0,
      workflow: accesos.value.workflow ? 1 : 0,
      anotaciones: accesos.value.anotaciones ? 1 : 0,
      vinculacion: accesos.value.vinculacion ? 1 : 0
    }

    //console.log('Guardando accesos:', payload)          //Usarlo solo para ver los errores en el testeo de Software

    const response = await axios.post(
      `/api/Accesos/guardar-accesos?idUsuarioSesion=${idUsuarioSesion}`,
      payload
    )

    if (response.data.success) {
      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡Éxito!',
        text: 'Accesos guardados correctamente',
        confirmButtonColor: '#ce501b',
        timer: 2500,
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal',
          confirmButton: 'swal-btn-confirmar'
        },
        showConfirmButton: true
      })
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudieron guardar los accesos',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
    }
  } catch (error) {
    //console.error('Error al guardar accesos:', error)       //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al guardar los accesos',
      customClass: {
        title: 'swal-title-custom',
        container: 'swal-sobre-modal'
      }
    })
  } finally {
    guardando.value = false
  }
}


</script>

<style scoped>
/* Estilos personalizados si los necesitas */
</style>

<style>

.swal-title-custom {
  color: #004d82 !important;
  font-size: 1.3rem !important;
}

.swal-text-custom {
  color: #555555 !important;
  font-size: 0.95rem !important;
}

.swal-btn-custom {
  background-color: #ce501b !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 8px 24px !important;
}

.swal-btn-custom:hover {
  background-color: #a83d14 !important;
}

.swal-btn-confirmar {
  color: white !important;
}

</style>

<style>
.swal-sobre-modal {
  z-index: 10000 !important;
}
</style>